<div class="flex-column gap p-2">
    <app-service-basic-info></app-service-basic-info>
    <app-workplace-table></app-workplace-table>
    <app-service-data-share></app-service-data-share>
</div>
